import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as source from '../metric'

export const RESOURCE = {
  payload: {
    canBeOptional: true,
    context: core.dms.models.Attribute.Id.Context.from({
      context: source.RESOURCE.payload.dimension.partialId,
      partialId: source.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    description: 'Maximum value of the metric',
    isOptional: true,
    name: 'Max',
    partialId: PartialId.Standard.create('max'),
    type: core.common.value.types.Intrinsic.Decimal,
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
